const firebase: any = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID
}
class FirebaseService {
    initializeEnvironment() {
        (window as any).sharedConfig = {
            firebase: firebase,
            cloudFunctionsUrl: process.env.REACT_APP_CLOUD_FUNCTIONS_URL,
            accountManagementUrl: process.env.REACT_APP_ACCOUNT_MANAGEMENT_URL,
            assetsHost: process.env.REACT_APP_BASE_URL,
            webAppHost: process.env.REACT_APP_WEB_APP_HOST_URL,
        };
    }
}

const firebaseInstance = new FirebaseService();

export default firebaseInstance;